"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _alert = _interopRequireDefault(require("./core/alert"));
var _loginConnector = _interopRequireDefault(require("../login/login-connector"));
var _loginForm = _interopRequireDefault(require("./core/login-form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_loginForm.default, null);
function requireAuthentication(Component) {
  return (0, _loginConnector.default)(props => {
    if (props.isAuthenticated) {
      return /*#__PURE__*/_react.default.createElement(Component, props);
    } else {
      return _ref;
    }
  });
}
var _default = exports.default = requireAuthentication;